import { render, staticRenderFns } from "./Pagina.vue?vue&type=template&id=586aed7e&scoped=true&"
import script from "./Pagina.vue?vue&type=script&lang=ts&"
export * from "./Pagina.vue?vue&type=script&lang=ts&"
import style0 from "./Pagina.vue?vue&type=style&index=0&id=586aed7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586aed7e",
  null
  
)

export default component.exports